<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="text-xs-center">
		<v-dialog
			v-model="modal"
			width="500">
			<template v-slot:activator="{ on }">
				<v-btn
					color="lightred"
					dark
					v-on="on"
					:disabled="disableNewSectionCreation">
					Dodaj sekcję formularza
				</v-btn>
			</template>
			<v-card>
				<v-card-title
					class="headline blue"
					primary-title>
					Utworzenie sekcji formularza
				</v-card-title>
				<div class="text-xs-center">
					<v-card-text>
						<span>Podaj nazwę sekcji</span>
						<v-flex>
							<v-text-field
								browser-autocomplete="off"
								label="nazwa"
								aria-label="section name"
								for="add-section-modal-name"
								id="add-section-modal-name"
								type="text"
								v-model="newSection"
								outline
							></v-text-field>
						</v-flex>
					</v-card-text>
				</div>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						@click="addNewSection"
					>
						Dodaj
					</v-btn>
					<v-btn
						color="blue"
						@click="closeModal"
					>
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: "AddSectionModal",

		methods: {
			addNewSection() {
				let newObjSection = {
					name: this.newSection,
					groups: [],
				};
				this.form.formSchema.sections.push(newObjSection);
				this.modal = false;
				this.clearModal();
				this.$forceUpdate();
			},

			closeModal() {
				this.modal = false;
				this.clearModal();
			},

			clearModal() {
				this.newSection = "";
			},
		},

		computed: {
			disableNewSectionCreation: function () {
				if (this.allowedMultipleSectionsFormTypes.includes(this.$route.params.formType)) {
					return false;
				} else {
					return this.form.formSchema.sections.length > 0;
				}
			}
		},

		data() {
			return {
				form: this.value,
				modal: false,
				newSection: "",
				allowedMultipleSectionsFormTypes: [
					"OFFER",
					"MODULE_OFFER",
				]
			};
		},

		props: {
			value: Object,
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},
	};
</script>

<style scoped>
	.theme--dark .red.lighten-2 {
		color: #000;
	}
</style>
